import { render } from "./BillingCustomerPage.vue?vue&type=template&id=2dc40939&ts=true"
import script from "./BillingCustomerPage.vue?vue&type=script&lang=ts"
export * from "./BillingCustomerPage.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__